module.exports = __webpack_public_path__ + "4b9a70e43206a4cc8a5ad328e2d3428f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-arrow-left-blue.svg
// module id = HtZT
// module chunks = 5